<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
          <el-row :gutter="20">
            <el-form ref="form" :model="form" :rules="rules" label-position="top">
              <el-col :span="24">
                <el-form-item label="电子回单：" prop="receiptPictures">
                  <upload-files3 v-model="form.receiptPictures"></upload-files3>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import UploadFiles3 from "@/components/UploadFiles3.vue";
import CustomTable from "@/components/CustomTable.vue";
import { freightSkip } from "@/views/commonApi";
export default {
  name: "AddOrEdit",
  components: {
    CustomTable,
    UploadFiles3,
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "50%",
        show: false,
        title: "该笔订单要求电子回单，请上传电子回单",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        "orderId": "",
        "pointId": "",
        "receiptPictures": []
      },
      detail: {},
      rules: {
        success: [{ required: true, message: "电子回单不能为空" }],
      },
    };
  },
  mounted() {},
  methods: {
    init(row) {
      this.form = Object.assign({}, row);
      this.dialogObj.show = true;
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          freightSkip(this.form)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("提交成功");
                this.$parent.handleAddOrEditSuccess();
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .order-detail-box {
    display: flex;
    width: 100%;
    height: 0.8rem;
    background: #f7fbff;
    padding: 0.1rem;
    border-radius: 0.08rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    .label-val {
      width: 33.3%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .label-1 {
        color: #8c8c8c;
        font-size: 0.12rem;
        padding-bottom: 0.06rem;
      }
      .value-1 {
        color: #434343;
      }
    }
    .label-val:after {
      content: "";
      position: absolute;
      right: 0;
      width: 0.01rem;
      height: 0.26rem;
      background: #dce5f5;
    }
    .label-val:nth-last-of-type(1):after {
      display: none;
    }
  }
  .order-detail-box1{
    .label-val{
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
    }
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .common-info-box {
    padding: 0.1rem;
    box-sizing: border-box;
    background: #f7f8fb;
    line-height: 0.24rem;
    border-radius: 0.08rem;
  }
  .common-image-box {
    margin-bottom: 0;
    margin-top: 0.04rem;
  }
  .invice-info {
    line-height: 0.24rem;
    margin-bottom: 0.2rem;
  }
  .radio-box {
    display: flex;
    align-items: center;
    span {
      font-size: 0.12rem;
      color: #8c8c8c;
    }
  }
}
</style>
